export const CommonUsesData = [
  {
    title: "Government",
    detail:
      "When it comes to governmental documents, security is of the utmost importance. You can be assured that your documents are at the secure hands of translators who will transform your documents into the language you intended. If you're looking for government translators, reach out now.",
    link: "/industries/government",
  },
  {
    title: "Medical",
    detail:
      "The medical field is one ripe with specialized terminologies. Whether for interacting with patients, for connecting healthcare providers with each other, or providing for the public with MedTech, our medical translators apply accuracy and quality to every medical translation and interpretation. Get started now.",
    link: "/industries/healthcare",
  },
  {
    title: "Legal",
    detail:
      "A legal translator has the specialist knowledge of the court system and of the law. They're equipped with the linguistic sensibilities to take your legal translations to the next level. If you're looking for corporate law translations, civic law translations, or more, you can get in touch now with any of our legal translators.",
    link: "/industries/legal-services",
  },
  {
    title: "Banking and Finance ",
    detail:
      "You don't want a medical translator to translate your financial documents. Only a financial translator will do. From cryptocurrency to eCommerce to traditional banking, the right financial translator can be found at Tomedes for your banking and finance needs. Why not reach out to us today?",
    link: "/industries/banking-finance",
  },
];

export const CommonUsesDataSecond = [
  {
    title: "Legal Documents",
    detail:
      "For the legal profession, types of documents range from affidavits, agreements, contracts and much more. Our legal translators are well-versed in these types of documents, and in the legal sector in general. Meanwhile, they also have the knowledge of two or more languages. Get started today.",
    link: "/",
  },
  {
    title: "Medical Documents",
    detail:
      "Documents for the medical field range from patient records, clinical history reports, lab results, and more. Being prepared to translate these medical documents are part and parcel of a medical translator's job. Their mastery of two or more languages plus their medical knowledge make them more than proficient.",
    link: "/",
  },
  {
    title: "Technical Documents",
    detail:
      "Technical documents in fields such as data science and engineering may require translation. Technical documents such as user manuals, product manuals, and more can be transformed into translation. This includes glossaries of specific terminologies as well.",
    link: "/",
  },
  {
    title: "Financial Documents",
    detail:
      "Financial documents are a necessary part of the everyday life of a business or an organization. These documents range from tax declarations, income statements, balance sheets, and much more. Tomedes translators have the know-how of the financial industry as well as of their specialized languages.",
    link: "/",
  },
];
